export default __webpack_public_path__ + "static/media/tsvetan_m.6da0fca7.jpg";